/* Установщик «Пост»: объект в window на том месте порядка скриптов, где стоял assets/bot-post.js.
   В серверном режиме движок шаблона получает сервер экрана (post-server.ts) и экран post встаёт в реестр движков студии;
   выбирает его только список экранов сборки (engine-kit/engine-default.json — пустой до коммита переключения, инвариант I4). */
import { isServerMode } from '../../platform/server-mode';
import { createPost } from './engine';
import { createPostServer, registerPostEngine } from './post-server';

export function installPost() {
  const server = isServerMode();
  createPost(server ? createPostServer : null);
  if (server) registerPostEngine();
}
